import { stats } from "@/mocks/home";

export default function Stats() {
  return (
    <section className="relative bg-background-50 py-16 md:py-20 px-4 md:px-8 border-y border-background-300/20">
      <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-6">
        {stats.map((stat, index) => (
          <div key={stat.label} className="reveal text-center">
            <div
              className={`font-heading text-4xl md:text-5xl font-semibold mb-2 ${
                index === stats.length - 1 ? "text-accent-400" : "text-foreground-950"
              }`}
            >
              {stat.value}
            </div>
            <div className="text-xs md:text-sm font-medium text-foreground-600 tracking-wide">
              {stat.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}